import type { CSSProperties, PropsWithChildren } from 'react'
import { Drawer } from 'vaul'

type SheetDrawerContentProps = PropsWithChildren & {
  contentStyle: CSSProperties
  handleWrapStyle: CSSProperties
  handleStyle: CSSProperties
  bodyStyle: CSSProperties
  // false — нет свайп-dismiss (обязательные шторки), граббер не рисуем.
  isHandleVisible?: boolean
}

export function SheetDrawerContent({
  contentStyle,
  handleWrapStyle,
  handleStyle,
  bodyStyle,
  isHandleVisible = true,
  children,
}: SheetDrawerContentProps) {
  let handle = null

  if (isHandleVisible) {
    handle = (
      <div style={handleWrapStyle}>
        <Drawer.Handle style={handleStyle} />
      </div>
    )
  }

  return (
    <Drawer.Content style={contentStyle} aria-describedby={undefined}>
      {handle}
      <div style={bodyStyle}>{children}</div>
    </Drawer.Content>
  )
}
